import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import './formpdfpreview.css';

// Use .js so production servers serve the module with a JavaScript MIME type.
// The preparation script copies the worker from React-PDF's exact dependency.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.${pdfjs.version}.min.js`;

export default function FormPdfPreview({ src, title }) {
  const container = useRef(null);
  const [width, setWidth] = useState(0);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [revision, setRevision] = useState(0);

  useEffect(() => { setPage(1); setPages(0); }, [src]);
  useEffect(() => {
    const element = container.current;
    const measure = () => setWidth(Math.max(0, Math.floor(element.clientWidth)));
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="form-pdf-preview" aria-label={title}>
      <div className="form-pdf-toolbar">
        <button type="button" disabled={page <= 1} onClick={() => setPage(value => value - 1)}>Previous page</button>
        <span aria-live="polite">{pages ? `Page ${page} of ${pages}` : 'Document preview'}</span>
        <button type="button" disabled={!pages || page >= pages} onClick={() => setPage(value => value + 1)}>Next page</button>
      </div>
      <div className="form-pdf-pages" ref={container}>
        {width > 0 && <Document key={`${src}-${revision}`} file={src?.split('#')[0]}
          onLoadSuccess={({ numPages }) => { setPages(numPages); setPage(1); }}
          onLoadError={() => setPages(0)}
          loading={<p role="status">Loading document...</p>}
          error={<div role="alert"><p>Unable to load the document preview.</p>
            <button type="button" onClick={() => setRevision(value => value + 1)}>Retry</button>{' '}
            <a href={src} target="_blank" rel="noopener noreferrer">Open document</a>
          </div>}>
          <Page pageNumber={page} width={width} devicePixelRatio={Math.min(window.devicePixelRatio || 1, 2)}
            renderTextLayer={false} renderAnnotationLayer={false} loading={<p role="status">Loading page...</p>} />
        </Document>}
      </div>
    </section>
  );
}
